import { Kunde } from '../features/kunde/api/types';
import { Aktivitaetsstatus } from '../features/mitarbeiter/api/types';

interface NameInterface {
  anrede: string;
  vorname: string;
  nachname: string;
  aktivitaetsstatus: Aktivitaetsstatus;
}

export function formatName<T extends NameInterface>(name: T, showAnrede = true) {
  return `${showAnrede ? `${name.anrede} ` : ''}${name.vorname} ${name.nachname}${name.aktivitaetsstatus === 'inaktiv' ? ` [${name.aktivitaetsstatus.toUpperCase()}]` : ''}`;
}

export function formatKundeAdresse(kunde: Kunde) {
  return `${kunde.strasse ?? ''} ${kunde.hausnummer ? `${kunde.hausnummer}, ` : ''} ${kunde.adresszusatz ? `${kunde.adresszusatz},` : ''} ${kunde.postleitzahl ?? ''} ${kunde.stadt ?? ''}`;
}
